export class PrinterNotFoundError extends Error {
  constructor() {
    super("Impressora não encontrada!");
    this.name = "PrinterNotFoundError";
  }
}
